import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { forwardRef, useMemo } from 'react';
import cn from 'classnames';
import styles from './Carousel.module.scss';
import { renderCarouselItem } from './Carousel.types';
import { CarouselArrowButton } from './CarouselArrowButton';
import { CarouselDraggableTrack } from './CarouselDraggableTrack';
export const CarouselViewport = /*#__PURE__*/ forwardRef((param, scrollerRef)=>{
    let { items, equalItemWidth, itemMinWidth, gap, fade, showArrows, canScrollLeft, canScrollRight, reorderable, onReorder, reorderBiName, dragMode, handleVisibility, dragActivation, handlePosition, viewportTestId, scrollerTestId, itemTestId, scrollLeftTestId, scrollRightTestId, scrollLeftAriaLabel, scrollRightAriaLabel, onScroll } = param;
    const trackStyle = useMemo(()=>({
            gap: "".concat(gap, "px"),
            '--carousel-item-min-width': "".concat(itemMinWidth, "px")
        }), [
        gap,
        itemMinWidth
    ]);
    const renderTrack = ()=>{
        if (reorderable) {
            return /*#__PURE__*/ _jsx(CarouselDraggableTrack, {
                items: items,
                equalItemWidth: equalItemWidth,
                gap: gap,
                onReorder: onReorder,
                itemTestId: itemTestId,
                reorderBiName: reorderBiName,
                dragMode: dragMode,
                handleVisibility: handleVisibility,
                dragActivation: dragActivation,
                handlePosition: handlePosition
            });
        }
        return /*#__PURE__*/ _jsx("div", {
            className: styles.track,
            style: trackStyle,
            children: items.map((item)=>/*#__PURE__*/ _jsx("div", {
                    "data-testid": itemTestId(item.id),
                    className: cn(styles.item, {
                        [styles.itemEqual]: equalItemWidth
                    }),
                    children: renderCarouselItem(item.content, {
                        isDragActive: false
                    })
                }, item.id))
        });
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.viewport,
        "data-testid": viewportTestId,
        children: [
            /*#__PURE__*/ _jsx("div", {
                ref: scrollerRef,
                className: styles.scroller,
                "data-testid": scrollerTestId,
                children: renderTrack()
            }),
            fade && /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: cn(styles.fade, styles.fadeLeft, {
                            [styles.fadeVisible]: canScrollLeft
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: cn(styles.fade, styles.fadeRight, {
                            [styles.fadeVisible]: canScrollRight
                        })
                    })
                ]
            }),
            showArrows && /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(CarouselArrowButton, {
                        direction: "left",
                        visible: canScrollLeft,
                        ariaLabel: scrollLeftAriaLabel,
                        testId: scrollLeftTestId,
                        onClick: ()=>onScroll('left')
                    }),
                    /*#__PURE__*/ _jsx(CarouselArrowButton, {
                        direction: "right",
                        visible: canScrollRight,
                        ariaLabel: scrollRightAriaLabel,
                        testId: scrollRightTestId,
                        onClick: ()=>onScroll('right')
                    })
                ]
            })
        ]
    });
});
CarouselViewport.displayName = 'CarouselViewport';
